import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'next/lib/date';
import {
  MILLISECONDS_PER_DAY,
  ABSOLUTE_TIME_OPERATORS,
  DEFAULT_OPERATORS,
  MULTI_VALUE_OPERATORS,
  NUMERIC_OPERATORS,
  RELATIVE_TIME_OPERATORS,
} from 'next/components/Conditions';
import { ConditionText } from './styled';
import { OPERATOR_NAMES } from './constants';

export const PropertyCondition = ({ property, operator, value }) => {
  const isDefaultOperator =
    DEFAULT_OPERATORS.has(operator) || NUMERIC_OPERATORS.has(operator);

  const numOfDays = Math.ceil(value / MILLISECONDS_PER_DAY);

  return (
    <ConditionText>
      user property {property} must {OPERATOR_NAMES[operator]}{' '}
      {isDefaultOperator && value}
      {MULTI_VALUE_OPERATORS.has(operator) &&
        `${value.split('\n').length} values`}
      {RELATIVE_TIME_OPERATORS.has(operator) &&
        `
          ${numOfDays} day${numOfDays > 1 ? 's' : ''} ago
        `}
      {ABSOLUTE_TIME_OPERATORS.has(operator) &&
        `
          ${format(value, 'MMMM Do YYYY')}
        `}
    </ConditionText>
  );
};

PropertyCondition.propTypes = {
  property: PropTypes.string.isRequired,
  operator: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
